import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from '@core/router/routes';
import { WINDOW } from '@core/tokens/window';
import { ProductGroupsComponent } from '@features/products-groups/product-groups.component';
import { Continually } from '@shared/models/external-scripts.model';
import { ProductListItem } from '@shared/models/product.model';
import { DataService } from '@shared/services/data.service';
import { SeoSocialShareService } from 'ngx-seo';
import { TestimonialsComponent } from '../../shared/testimonials/testimonials.component';
import { StatsBlockComponent } from '../../shared/stats-block/stats-block.component';
import { TextBlockComponent } from '../../shared/text-block/text-block.component';
import { QuoteBlockComponent } from '../../shared/quote-block/quote-block.component';
import { PartnersLogosComponent } from '../../shared/partners-logos/partners-logos.component';
import { PopularGridComponent } from '../../shared/popular-grid/popular-grid.component';
import { ExploreGridComponent } from '../../shared/explore-grid/explore-grid.component';
import { NewsletterComponent } from '../../shared/newsletter/newsletter.component';
import { HomeHeroComponent } from './home-hero/home-hero.component';
import { SearchInputComponent } from '../../shared/search-input/search-input.component';
import { FetchDataPayloadParams } from '@shared/models/data.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SearchInputComponent,
    HomeHeroComponent,
    NewsletterComponent,
    ExploreGridComponent,
    PopularGridComponent,
    PartnersLogosComponent,
    QuoteBlockComponent,
    TextBlockComponent,
    StatsBlockComponent,
    TestimonialsComponent,
  ],
})
export class HomeComponent extends ProductGroupsComponent {
  constructor(
    @Inject(WINDOW) public readonly window: Window & typeof globalThis & { continually?: Continually },
    dataService: DataService<ProductListItem>,
    protected seoSocialShareService: SeoSocialShareService,
    protected router: Router
  ) {
    super(seoSocialShareService, router, dataService);

    this.seoSocialShareService.setData({
      title: 'Charity Booster - #1 Marketplace for Charity Events',
      description:
        'Charity Booster is your go-to marketplace for charity events. Access professionals, products, and resources to amplify your mission & reduce fundraising stress.',
    });
  }

  public loadChatBox(): void {
    if (this.window?.continually?.startConversation) {
      this.window.continually.startConversation();
    }
  }

  public search(value: string): void {
    this.router.navigate([AppRoutes.Products], {
      queryParams: {
        [FetchDataPayloadParams.Search]: value,
      },
      queryParamsHandling: 'merge',
    });
  }
}
